
import Vue, { PropType } from 'vue';

// Services & types
import CandidateService from '~/services/CandidateService';
import { CandidateStudyProgram } from '~/services/CSPService';
import {
    CandidateJobBuilder,
    CandidateJobBuilderChangeEvent,
    commonProps,
    setupBuilder,
} from '~/utils/candidate';
import SchoolVerificationService from '~/services/SchoolVerificationService';
import { ImportSection } from '~/services/types/import';

// Components
import StudyProgramsForm from '../forms/StudyProgramsForm.vue';
import ProfileModal from './ProfileModal.vue';
import ImportBox from '~/components/profile/components/ImportBox.vue';

export default Vue.extend({
    name: 'StudyProgramsModal',
    components: {
        ProfileModal,
        StudyProgramsForm,
        ImportBox,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        ...commonProps(),
        studyPrograms: {
            type: Array as PropType<CandidateStudyProgram[]>,
            required: true,
        },
        importSection: {
            type: Object as PropType<ImportSection | undefined>,
            required: false,
            default: undefined,
        },
        programId: {
            type: String || null,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            verificationService: new SchoolVerificationService(),
            builder: null as CandidateJobBuilder | null,
            service: new CandidateService(),
            isLoading: false,
            isFormValid: true,
            isFormOpen: false,
            hasUnsavedChanges: false,
        };
    },
    computed: {
        saveDisabled(): boolean {
            return !this.hasUnsavedChanges || !this.isFormValid || this.isFormOpen;
        },
    },
    methods: {
        handleBuilderChange(evt: CandidateJobBuilderChangeEvent) {
            this.hasUnsavedChanges = !evt.empty;
        },
        async handleSave() {
            if (!this.builder) return;

            const request = this.builder.buildRequest();
            this.isLoading = true;

            this.removeVerifications();
            await this.service.updateCandidateProfile(request);

            this.resetBuilder();
            this.$emit('close');
            this.isLoading = false;
        },
        removeVerifications(): void {
            if (!this.builder || !this.builder.hasRemovedVerifications) return;

            Promise.all(
                this.builder.removedVerifications.map(schoolId =>
                    this.verificationService.delete(schoolId)
                )
            ).finally(() => {
                this.$interfaces.university.connection.get({ forceUpdate: true });
            });
        },
        resetBuilder() {
            this.tearDownBuilder();

            this.builder = setupBuilder.apply(this);
            this.builder.on('change', this.handleBuilderChange);
        },
        tearDownBuilder() {
            if (this.builder) this.builder.off('change', this.handleBuilderChange);
            this.builder = null;
        },
    },
    beforeDestroy() {
        this.tearDownBuilder();
    },
    watch: {
        show: {
            handler(val: boolean) {
                if (val) {
                    this.resetBuilder();
                }
            },
            immediate: true,
        },
    },
});
